// duplicated import of gesture handler is required for bottom sheet modal to work on android
/* eslint-disable import/no-duplicates */
import { BottomSheetModalProvider } from '@gorhom/bottom-sheet'
import { QueryClientProvider } from '@tanstack/react-query'
import { NativeBaseProvider } from 'native-base'
import React, { PropsWithChildren } from 'react'
import { StyleSheet } from 'react-native'
import { GestureHandlerRootView } from 'react-native-gesture-handler'

import { AuthProvider } from './AuthProvider'
import { FiltersProvider } from './FiltersProvider'
import { NotificationsProvider } from './NotificatedProvider'

import { AppLoading } from '~components'
import { theme, nativeBaseConfig } from '~constants'
import { useAppStateActive } from '~hooks'
import { queryClient } from '~queryClient'
import { colorModeManager } from '~services'
import { checkForUpdates } from '~utils'

export const Providers = ({ children }: PropsWithChildren): JSX.Element => {
  useAppStateActive(checkForUpdates, false)
  return (
    <NativeBaseProvider theme={theme} colorModeManager={colorModeManager} config={nativeBaseConfig}>
      {/* NativeBaseProvider includes SafeAreaProvider so that we don't have to include it in a root render tree */}
      {/* @ts-expect-error: error comes from a react-native-notificated library which doesn't have declared children in types required in react 18 */}
      <NotificationsProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <AppLoading>
              <GestureHandlerRootView style={styles.gestureHandlerRootView}>
                <BottomSheetModalProvider>
                  <FiltersProvider>{children}</FiltersProvider>
                </BottomSheetModalProvider>
              </GestureHandlerRootView>
            </AppLoading>
          </AuthProvider>
        </QueryClientProvider>
      </NotificationsProvider>
    </NativeBaseProvider>
  )
}

const styles = StyleSheet.create({
  gestureHandlerRootView: {
    flex: 1,
  },
})
